import "./tablestyle.scss";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { checkAvailability } from "../../utils/EllowUtils";
import { SortDescriptor } from "@progress/kendo-data-query";
import { useState } from "react";
import { Icon } from '@iconify/react';


const AppliedResourcesTable = (props: any) => {
  
  const initialSort: Array<SortDescriptor> = [
    { field: "name", dir: "asc" },
  ];

  const [sort, setSort] = useState(initialSort);

  const skillsCell = (props: GridCellProps) => {
    let length = props.dataItem.skills && props.dataItem.skills.length;
    return (
      <td >
         <div className="skillsWrap">
          {props.dataItem.skills && props.dataItem.skills.map((item: string, key: number)  => {
             return ((item) +  (key < length-1 ?     ' , ' : ''))          })}
        </div>
      </td>
    )
  }
  
  const experienceCell = (props: GridCellProps) => {
    return <td>{props.dataItem.experience + " Years"}</td>;
  }

  const availablityCell = (props: GridCellProps) => {  
    
    let data = {
      availability: props.dataItem.availability, 
      availability_date: props.dataItem.availability_date,
      availability_week: props.dataItem.availability_week,
      contractEndDate: props.dataItem.contractMetadata.contractEndDate,
      contractStartDate: props.dataItem.contractMetadata.contractStartDate
    }
       
    return (
      <td>
        {checkAvailability(data)}
      </td>
    )
  }

  const positionCell = (props: GridCellProps) => {    
    return(
      <td>
        {props.dataItem.positionStatus}
      </td>
    )
  }

  const nameCell = (props: GridCellProps, redirection: any) => {
    const profileImage = props.dataItem.googleProfileImage ?  props.dataItem.googleProfileImage : " " 
    return (
      <td>
        <div className="userInfo" onClick={() => redirection(props.dataItem.loginId)}>
            {profileImage === " "? 
             <figure>{props.dataItem && props.dataItem.firstName && props.dataItem.firstName[0]}{props.dataItem && props.dataItem.lastName && props.dataItem.lastName[0]}</figure>
            :
            <figure><img alt="" src={ profileImage }></img></figure> }
            {props.dataItem.name}
        </div>
      </td>
    )
  }

  const viewButton = (props: GridCellProps) => {    
    return(
      <td>
    
      </td>
    )
  }

  const redirection = (candidateLoginId: string) => {
    // navigate('../createResources', { state: { candidateLoginId: candidateLoginId, tab: 4 }})
  }

  return (
    <div className='tableStyle no-top-padd no-min-height tableMaxHeight'>
    <Grid
        data={props.state.items}
        sortable={true}
        sort={sort}
        onSortChange={(e) => {
          setSort(e.sort);
        }}
    >
      <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
      <Column field="name" title="Name" className="pointer" cell={(props: GridCellProps) => nameCell(props, (candidateLoginId: string) => redirection(candidateLoginId))}/>
      <Column field="Skills" title="Skills" cell={skillsCell} />
      <Column field="experience" title="Experience" cell={experienceCell} />
      <Column field="ellowStatus" title="ellow Status"/>
      <Column field="availabilityValue" title="Availability" cell={availablityCell} />
      {/* <Column field="dateOfRegistration" title="Resource Cost" cell={resourcecostCell}/> */}
      {/* <Column field="positionEllowRate" title="ellow Rate" cell={ellowrateCell} /> */}
      <Column field="positionStatus" title="Position Status"  cell={positionCell}/>
      <Column cell={viewButton} />
      </Grid>
    </div>
  )
}

export default AppliedResourcesTable;

